import {fetchMetaDataApi} from '../../services/common-api';
import {fetchMonthlyIntakeBookDetailsApi, submitMonthlyIntakeBookDetailsApi, submitSelectedDailyIntakeDetailsApi,submitUnblockContractRequestApi} from '../../services/business-partner-api';

export const fetchMetaData = () => {
    return fetchMetaDataApi(3);
}

export const fetchMonthlyIntakeBookDetails = (bpCode, intakeBookDate) => {
    return fetchMonthlyIntakeBookDetailsApi(bpCode, intakeBookDate); 
}

export const submitMonthlyIntakeBookDetails = (intakeBookRequestData) => {
    return submitMonthlyIntakeBookDetailsApi(intakeBookRequestData);
}

export const submitSelectedDailyIntakeDetails = (intakeBookRequestData) => {
    return submitSelectedDailyIntakeDetailsApi(intakeBookRequestData);
}

export const submitMonthlyUnblockContractRequest = (unblockRequestData) => {
    return submitUnblockContractRequestApi(unblockRequestData);
}